import { Theme } from '@material-ui/core/styles';

export const getMuiSelect = (theme: Theme): Record<string, unknown> => ({
  MuiSelect: {
    root: {
      alignItems: 'center',
      display: 'flex',
    },

    select: {
      '&:focus': {
        backgroundColor: theme.palette.common.white,
      },
    },
  },
});
